import gtmPusher from '../../utils/gtmPusher';

const stepAnalytics = (virtualPath, label, step) => {
  // GOOGLE ANALYTICS
  const pageViewObj = {
    event: 'virtualPageview',
    eventCategory: 'virtual pageview',
    eventAction: 'teamsport funnel',
    eventLabel: virtualPath,
    eventValue: 0,
    eventNonInteraction: false,
    virtualPath,
  };
  gtmPusher(pageViewObj, null);

  const ecommerceObj = {
    event: 'configurator',
    eventCategory: 'configurator',
    eventAction: step,
    eventLabel: label,
    eventValue: 0,
    eventNonInteraction: false,
    virtualPath,
  };
  gtmPusher(ecommerceObj, null);
  // -- END GOOGLE ANALYTICS --
};

export default stepAnalytics;
